// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bWmW","left":"styles_left__EIdcA"};